// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd8f08b6","239":"55beac6e","453":"5f74e72f","455":"81b55df6"}[chunkId] + ".chunk.js";
};